import React from 'react';
import { X, Plus, Minus, Trash2 } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';

const CartSidebar = ({
  isOpen,
  onClose,
  cartItems,
  cartTotal,
  onAdd,
  onRemove,
  onClear,
  onSendWhatsApp,
}) => (
  <>
    {/* Backdrop */}
    {isOpen && (
      <div
        data-testid="cart-backdrop"
        className="fixed inset-0 bg-black/50 z-50 backdrop-blur-sm"
        onClick={onClose}
      />
    )}

    {/* Sidebar */}
    <div
      data-testid="cart-sidebar"
      className={`fixed top-0 right-0 h-full w-full max-w-sm bg-white z-50 flex flex-col shadow-2xl transition-transform duration-300 ease-in-out ${
        isOpen ? 'translate-x-0' : 'translate-x-full'
      }`}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-6 py-5 border-b border-[#EBE5DB]">
        <div>
          <h2 className="font-serif text-xl font-bold text-[#2C2C2A]">
            Tu Pedido
          </h2>
          {cartItems.length > 0 && (
            <p className="text-xs text-[#8A8A87] mt-0.5">
              {cartItems.reduce((s, i) => s + i.quantity, 0)} unidades
            </p>
          )}
        </div>
        <button
          data-testid="close-cart"
          onClick={onClose}
          className="p-2 hover:bg-[#F5F0E8] transition-colors"
          aria-label="Cerrar carrito"
        >
          <X size={20} />
        </button>
      </div>

      {/* Items */}
      <div className="flex-1 overflow-y-auto">
        {cartItems.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-center px-8">
            <div className="w-16 h-16 bg-[#F5F0E8] flex items-center justify-center mb-4">
              <span className="text-2xl">🧺</span>
            </div>
            <p className="font-serif text-lg font-bold text-[#2C2C2A] mb-2">
              Tu carrito está vacío
            </p>
            <p className="text-[#8A8A87] text-sm">
              Añade croquetas del catálogo para hacer tu pedido
            </p>
          </div>
        ) : (
          <div className="px-6 py-4 space-y-1">
            {cartItems.map((item) => (
              <div
                key={item.id}
                data-testid={`cart-item-${item.id}`}
                className="flex items-center gap-4 py-4 border-b border-[#EBE5DB] last:border-b-0"
              >
                <div className="w-14 h-14 overflow-hidden flex-shrink-0">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-serif font-bold text-xs text-[#2C2C2A] leading-tight mb-1">
                    {item.name}
                  </h4>
                  <p className="text-[#B8860B] text-sm font-bold">
                    {(item.price * item.quantity).toFixed(2)}€
                  </p>
                  <p className="text-[#888780] text-xs">
                    {item.price.toFixed(2)}€/u
                  </p>
                </div>
                <div className="flex items-center gap-1.5">
                  <button
                    data-testid={`cart-decrease-${item.id}`}
                    onClick={() => onRemove(item.id)}
                    className="w-7 h-7 border border-[#EBE5DB] flex items-center justify-center hover:bg-[#F5F0E8] hover:border-[#2C2C2A] transition-colors"
                  >
                    <Minus size={11} />
                  </button>
                  <span className="w-6 text-center text-sm font-bold text-[#2C2C2A]">
                    {item.quantity}
                  </span>
                  <button
                    data-testid={`cart-increase-${item.id}`}
                    onClick={() => onAdd(item)}
                    className="w-7 h-7 border border-[#EBE5DB] flex items-center justify-center hover:bg-[#F5F0E8] hover:border-[#2C2C2A] transition-colors"
                  >
                    <Plus size={11} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Footer */}
      {cartItems.length > 0 && (
        <div className="px-6 py-5 border-t border-[#EBE5DB] bg-white">
          <div className="flex items-baseline justify-between mb-1">
            <span className="text-sm text-[#5A5A58]">Total aproximado</span>
            <span
              data-testid="cart-total"
              className="font-serif text-2xl font-bold text-[#B8860B]"
            >
              {cartTotal.toFixed(2)}€
            </span>
          </div>
          <p className="text-xs text-[#8A8A87] mb-5">
            Pago por Bizum o efectivo al recoger
          </p>

          <button
            data-testid="send-whatsapp-order"
            onClick={onSendWhatsApp}
            className="w-full flex items-center justify-center gap-3 bg-[#25D366] text-white py-4 text-sm font-bold uppercase tracking-widest hover:bg-[#1DA851] transition-colors mb-3 rounded-none"
          >
            <FaWhatsapp size={20} />
            Enviar Pedido por WhatsApp
          </button>

          <button
            data-testid="clear-cart"
            onClick={onClear}
            className="w-full flex items-center justify-center gap-2 border border-[#EBE5DB] text-[#8A8A87] py-3 text-xs hover:border-[#2C2C2A] hover:text-[#2C2C2A] transition-colors rounded-none"
          >
            <Trash2 size={13} />
            Vaciar carrito
          </button>
        </div>
      )}
    </div>
  </>
);

export default CartSidebar;
